import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import GlassCard from '../UI/GlassCard';
import CyberButton from '../UI/CyberButton';
import HUDElement from '../UI/HUDElement';
import NeonText from '../UI/NeonText';

const ProjectShowcase = ({ limit }) => {
    const [activeProject, setActiveProject] = useState(0);

    const projects = [
        {
            id: 1,
            title: 'Sistema de Reconocimiento Neural',
            category: 'IA & Machine Learning',
            description: 'Plataforma avanzada de reconocimiento facial y de patrones para seguridad urbana.',
            image: '/api/placeholder/400/250',
            technologies: ['Python', 'TensorFlow', 'OpenCV', 'Neural Networks'],
            status: 'Completado',
            progress: 100,
            metrics: [
                { label: 'Precisión', value: 99.8, unit: '%' },
                { label: 'Procesamiento', value: 240, unit: 'fps' },
                { label: 'Latencia', value: 4.2, unit: 'ms' }
            ]
        },
        {
            id: 2,
            title: 'Quantum Encryption Network',
            category: 'Ciberseguridad',
            description: 'Red de comunicación segura utilizando encriptación basada en principios cuánticos.',
            image: '/api/placeholder/400/250',
            technologies: ['Q#', 'Quantum SDK', 'Node.js', 'Blockchain'],
            status: 'En Desarrollo',
            progress: 75,
            metrics: [
                { label: 'Seguridad', value: 100, unit: '%' },
                { label: 'Velocidad', value: 15, unit: 'Gbps' },
                { label: 'Nodos', value: 128, unit: '' }
            ]
        },
        {
            id: 3,
            title: 'Neuro-Link Interface',
            category: 'Neuro-Interfaces',
            description: 'Interfaz no invasiva para control de dispositivos mediante señales cerebrales.',
            image: '/api/placeholder/400/250',
            technologies: ['C++', 'EEG', 'Signal Processing', 'React Native'],
            status: 'Fase de Pruebas',
            progress: 60,
            metrics: [
                { label: 'Precisión', value: 92.5, unit: '%' },
                { label: 'Tiempo Respuesta', value: 120, unit: 'ms' },
                { label: 'Canales', value: 32, unit: '' }
            ]
        }
    ];

    const displayedProjects = limit ? projects.slice(0, limit) : projects;

    return (
        <div className="project-showcase">
            <div className="project-navigation">
                {displayedProjects.map((project, index) => (
                    <CyberButton
                        key={project.id}
                        variant={activeProject === index ? 'cyan' : 'outline'}
                        size="small"
                        onClick={() => setActiveProject(index)}
                        className="project-nav-btn"
                    >
                        {project.category}
                    </CyberButton>
                ))}
            </div>

            <AnimatePresence mode="wait">
                <motion.div
                    key={activeProject}
                    className="project-display"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                >
                    <GlassCard className="project-card">
                        <div className="project-card__header">
                            <div className="project-meta">
                                <NeonText variant="cyan" size="large">
                                    {displayedProjects[activeProject].title}
                                </NeonText>
                                <span className="project-status">
                  STATUS: {displayedProjects[activeProject].status}
                </span>
                            </div>
                            <HUDElement
                                label="Progreso"
                                value={displayedProjects[activeProject].progress}
                                unit="%"
                                percentage={displayedProjects[activeProject].progress}
                            />
                        </div>

                        <div className="project-content">
                            <div className="project-image">
                                <div className="image-placeholder">
                                    [Visualización del Proyecto: {displayedProjects[activeProject].title}]
                                </div>
                            </div>

                            <div className="project-info">
                                <p className="project-description">
                                    {displayedProjects[activeProject].description}
                                </p>

                                <div className="project-metrics">
                                    {displayedProjects[activeProject].metrics.map((metric, index) => (
                                        <HUDElement
                                            key={index}
                                            label={metric.label}
                                            value={metric.value}
                                            unit={metric.unit}
                                            variant="compact"
                                        />
                                    ))}
                                </div>

                                <div className="project-technologies">
                                    <h4>Tecnologías Implementadas:</h4>
                                    <div className="tech-tags">
                                        {displayedProjects[activeProject].technologies.map((tech, index) => (
                                            <span key={index} className="tech-tag">
                        {tech}
                      </span>
                                        ))}
                                    </div>
                                </div>

                                <div className="project-actions">
                                    <CyberButton variant="cyan">
                                        Ver Demo
                                    </CyberButton>
                                    <CyberButton variant="magenta">
                                        Documentación
                                    </CyberButton>
                                </div>
                            </div>
                        </div>
                    </GlassCard>
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default ProjectShowcase;